export default __webpack_public_path__ + "static/media/detail.38b5eb5b.png";